import { Box, Button, IconButton, LinearProgress, Paper, Tooltip, Typography } from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../App";
import { usePrevious } from "../../components/CustomHooks";
import useApi, { WEB_SOCKET_TOPIC_CARRILES, WEB_SOCKET_TOPIC_TAGS } from "../../api";
import TableLoader from "../../components/TableLoader";
import EmptyStateLabel from "../../components/EmptyStateLabel";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { GRID_DEFAULT_PAGINATION_MODEL } from "../../components/DataGrid";
import normalizeFiltros from "../../components/app/Filtros";
import Icon from "@mdi/react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { consultarRegistrosTag, consultarTag } from "../../api/controlador";
import { formatDateInYear } from "../../components/Formatter";
import { mdiBoomGateArrowUp } from '@mdi/js';
import { mdiLocationExit } from '@mdi/js';
import { mdiCarOff } from '@mdi/js';
import { mdiCarInfo } from '@mdi/js';
import RegistrarIncidenciaDialog from "../acciones/RegistrarIncidenciaDialog";
import AperturaManualDialog from "../acciones/AperturaManualDialog";
import Panel from "../../components/Panel";
import CerrarEstanciaPensionado from "../acciones/CerrarEstanciaPensionado";
import DetalleEstanciaDialog from "../estancias/DetalleEstanciaDialog";
import { useSubscription } from "react-stomp-hooks";
import { isJSON } from "validator";
import { isObject } from "lodash";

const TIPO_TAG = {
    'PENSIONADO': 'Pensionado',
    'VALET': 'Valet',
}

export const renderTipoTag = (tag) => {
    return TIPO_TAG[tag.tipo] || 'Comercial';
}

const defaultFiltros = {
    query: ''
}

export default function ListadoRegistrosTag({ ...props }) {
    const { reload } = props;
    const navigate = useNavigate();
    //const { cuenta } = useContext(AppContext);

    const { prefijo, numero } = useParams();

    const [filtros, setFiltros] = useState(defaultFiltros);

    const [paginationModel, setPaginationModel] = useState(GRID_DEFAULT_PAGINATION_MODEL);
    const prevDataPM = usePrevious(paginationModel);
    //const prevQuery = usePrevious(filtros.query);

    const [rowCount, setRowCount] = useState(0);

    const [registros, setRegistros] = useState(null);
    const [tag, setTag] = useState(null);

    const [{ data: tagData, loading: loadingTag }, tagApi] = useApi();
    const [{ data: registrosData, loading: loadingUsuarios }, registrosApi] = useApi();

    useSubscription(`${WEB_SOCKET_TOPIC_TAGS}/${prefijo}/${numero}`, (message) => {
        console.log('Mensaje desde el websocket para los registros del tag', message);
        if (isJSON(message.body)) {
            const messageData = JSON.parse(message.body);
            if (messageData && isObject(messageData)) {
                //console.log('Mensaje de carriles', messageData);
                setRowCount(messageData.page.totalElements);
                setRegistros(messageData.content || []);
            }
        }
    });

    useEffect(() => {
        realizarConsultaRegistros();
        realizarConsultaTag();
    }, []);

    useEffect(() => {
        if (reload) {
            realizarConsultaRegistros();
        }
    }, [reload]);

    useEffect(() => {
        if (prevDataPM && (paginationModel.page !== prevDataPM.page || paginationModel.pageSize !== prevDataPM.pageSize)) {
            realizarConsultaRegistros();
        }
    }, [paginationModel]);

    useEffect(() => {
        if (registrosData) {
            setRowCount(registrosData.page.totalElements);
            setRegistros(registrosData.content || []);
        }
    }, [registrosData]);

    useEffect(() => {
        if (tagData) {
            setTag(tagData);
        }
    }, [tagData]);

    const realizarConsultaRegistros = (resetPM = false) => {
        setRegistros(null);
        if (resetPM) {
            setPaginationModel(GRID_DEFAULT_PAGINATION_MODEL);
        }
        registrosApi(consultarRegistrosTag(prefijo, numero, normalizeFiltros(filtros), resetPM ? GRID_DEFAULT_PAGINATION_MODEL : paginationModel));
    }

    const realizarConsultaTag = () => {
        tagApi(consultarTag(prefijo, numero))
    }

    const handleRegistrarIncidencia = (row) => () => {
        navigate(`incidencia`, { state: { tags: [{ prefijo, numero }], registros: [row.estanciaId] } });
    }

    const handleRegistrarAperturaManual = (sentido) => {
        navigate(`aperturaManual`, { state: { ...tag, sentido } });
    }

    const handleCierreEstanciaPensionado = (row) => () => {
        navigate(`cerrarEstanciaPension`, { state: { tags: [{ prefijo, numero }], registros: [row.estanciaId] } });
    }

    const handleVerDetalleEstancia = useCallback(row => () => {
        navigate(`detalleEstancia/${row.estanciaId}`, { state: { tag: { prefijo, numero, tipo: tag && tag.tipo } } });
    }, [tag])

    const handleUpdateList = () => {
        realizarConsultaRegistros();
    }

    const columns = useMemo(() => [
        {
            field: 'nombreCarril', headerName: 'Carril', minWidth: 200, flex: 1,
        },
        {
            field: 'fechaHora', headerName: 'Fecha', minWidth: 130,
            valueGetter: value => formatDateInYear(value, 'MMM D', ' HH:mm', ', YYYY')
        },
        {
            field: 'tipoEvento', headerName: 'Evento', width: 120,
        },
        {
            field: 'tipoEstancia', headerName: 'Tipo', width: 110,
        },
        {
            field: 'descripcion', headerName: 'Descripción', minWidth: 200, flex: 1,
        },
        {
            field: 'actions', headerName: 'Acciones', type: 'actions', width: 110,
            getActions: (params) => {
                var actions = [];
                if (params.row.registraIncidencia) {
                    actions.push(
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Registrar incidencia">
                                    <Icon path={mdiCarOff} size={0.9} />
                                </Tooltip>
                            }
                            label="Registrar incidencia"
                            onClick={handleRegistrarIncidencia(params.row)}
                        />
                    )
                }
                if (params.row.registraAperturaManual) {
                    actions.push(
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Apertura manual">
                                    <Icon path={mdiBoomGateArrowUp} size={0.9} />
                                </Tooltip>
                            }
                            label="Apertura manual"
                            onClick={() => handleRegistrarAperturaManual('SALIDA')}
                        />
                    )
                }
                if (params.row.registraCierreEstanciaPensionado) {
                    actions.push(
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Cierre estancia pensionado">
                                    <Icon path={mdiLocationExit} size={0.9} />
                                </Tooltip>
                            }
                            label="Apertura manual"
                            onClick={handleCierreEstanciaPensionado(params.row)}
                        />
                    )
                }
                if (params.row.verDetalleEstancia) {
                    actions.push(
                        <GridActionsCellItem
                            icon={
                                <Tooltip title="Ver detalle estancia">
                                    <Icon path={mdiCarInfo} size={0.9} />
                                </Tooltip>
                            }
                            label="Apertura manual"
                            onClick={handleVerDetalleEstancia(params.row)}
                        />
                    )
                }
                return actions
            }
        }
    ], [tag]);

    return (
        <>
            <Outlet />
            <Panel>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
                    <IconButton onClick={() => navigate(-1)} color="secondary">
                        <ArrowBackIcon />
                    </IconButton>
                    <Box>
                        <Typography variant="body1" color="secondary" sx={{ fontWeight: 450 }}>Registros del tag</Typography>
                        <Typography variant="body1">{`${prefijo} ${numero} `}{tag ? `(${renderTipoTag(tag)})` : '...'}</Typography>
                    </Box>
                </Box>
                {tag && tag.tipo === 'PENSIONADO' &&
                    <Box sx={{ mt: 2 }}>
                        <Button variant="outlined" color="secondary" onClick={() => handleRegistrarAperturaManual('ENTRADA')}>Acceso Manual</Button>
                    </Box>
                }
                {loadingTag && <LinearProgress />}
            </Panel >
            <Box sx={{ mt: 2 }}>
                {loadingUsuarios &&
                    <TableLoader columns={columns} rowsNum={5} />
                }
                {registros && registros.length === 0 &&
                    <EmptyStateLabel text="No existen registros con esos criterios" />
                }
                {registros && registros.length > 0 &&
                    <Paper elevation={0} sx={{ width: '100%', borderRadius: 6 }}>
                        <DataGrid
                            sx={{
                                borderRadius: 6,
                                "& .MuiDataGrid-row:hover": {
                                    backgroundColor: "inherit", // Or 'transparent' or whatever color you'd like
                                },
                                '& .MuiDataGrid-cell:hover': {
                                    cursor: 'default',
                                },
                            }}
                            autoHeight
                            disableRowSelectionOnClick
                            columns={columns}
                            rows={registros}
                            rowCount={rowCount}
                            loading={loadingUsuarios}
                            pageSizeOptions={[10]}
                            paginationModel={paginationModel}
                            paginationMode="server"
                            onPaginationModelChange={setPaginationModel}
                            onRowClick={(params, event) => {
                                // const url = grupoOperadorIdIn ? `registrosgrupo/${params.row.id}` : `${params.row.id}`;
                                // const estacionamientoId = params.row.estacionamientoId;
                                // navigate(`${url}`, { state: { grupoOperadorId: grupoOperadorId, estacionamientoId } });
                                //notificar('Cliente seleccionado: ' + params.row.nombre);
                            }}
                        />
                    </Paper>
                }
            </Box>
            <Routes>
                <Route path="incidencia" element={<RegistrarIncidenciaDialog onShouldUpdate={handleUpdateList} />} />
                <Route path="aperturaManual" element={<AperturaManualDialog onShouldUpdate={handleUpdateList} />} />
                <Route path="cerrarEstanciaPension" element={<CerrarEstanciaPensionado onShouldUpdate={handleUpdateList} />} />
                <Route path="detalleEstancia/:estanciaId" element={<DetalleEstanciaDialog />} />
            </Routes>
        </>
    );
}